import './new-invoice.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormInvoice from "../form-invoice/form-invoice";
import { useNewInvoice } from './new-invoice.hook';

export function NewInvoice() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewInvoice();

  return (
    <div id="NewInvoice" className="invoice">
      <HeaderContent
        title={<h1>New Invoice</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormInvoice />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewInvoice;